import useLocale from "../../../../../hooks/useLocale";
import { APPEARING, FROM, RESULTS, TO, ZERO } from "./paginationLabelConstants";

const GovGrPaginationLabel = ({
  count = ZERO,
  rowsPerPage = ZERO,
  currentPage = ZERO,
}) => {
  const { t } = useLocale();

  const currentShownFrom = () => {
    if (count > 0) {
      return (rowsPerPage * currentPage + 1) / 1 - rowsPerPage;
    } else {
      return 0;
    }
  };

  const currentShownTo = () => {
    if (currentPage * rowsPerPage >= count) {
      return count;
    }
    return (currentPage + 1) * rowsPerPage - rowsPerPage;
  };

  return (
    <p className="govgr-pagination__label">
      {t(APPEARING)} <b>{currentShownFrom()}</b> {t(TO)}{" "}
      <b>{currentShownTo()}</b> {t(FROM)} <b>{count}</b> {t(RESULTS)}
    </p>
  );
};

export default GovGrPaginationLabel;
